import http from "./http";

function getdriverlistforVehicleprofile(data) {
  return http.post(`vehicle_DriverList`, data);
}

function getGeofencingdata(data) {
  return http.post(`assign_geofenc_report`, data);
}

function getRouteMapData(data) {
  return http.post(`vehicle_viaList`, data);
}
function deleteSingleRouteindashboard(data) {
  return http.post(`vehicleRoutesDelete`, data);
}

function getTripReportData(data) {
  return http.post(`tripReport`, data);
}

function getTripTimelineData(data) {
  return http.post(`gpsData`, data);
}

function getvehicleAlertdata(data) {
  return http.post(`vehiclealertReport`, data);
}

function fetchAlertTimedata(data) {
  return http.post(`VehicleAlertList`, data);
}

function saveAlertTime(data) {
  return http.post(`SaveAlert`, data);
}

function deleteAlertTime(data) {
  return http.post(`DeleteAlertList`, data);
}

function fetch_vehicle_alloted_data(data) {
  return http.post(`vehicleAssignList`, data);
}

const vehicleProfileService = {
  getdriverlistforVehicleprofile,
  getGeofencingdata,
  getRouteMapData,
  deleteSingleRouteindashboard,
  getTripReportData,
  getTripTimelineData,
  getvehicleAlertdata,
  fetchAlertTimedata,
  saveAlertTime,
  deleteAlertTime,
  fetch_vehicle_alloted_data,
};

export default vehicleProfileService;
